import React, { useEffect, useMemo } from "react";

const ANDROID_PACKAGE = "com.anonymous.shefscloud_mobile";
const IOS_APP_STORE_URL = ""; // TODO: add once the iOS listing exists

export default function GetAppDishes() {
  const { appLink, playStoreUrl } = useMemo(() => {
    const incoming = new URLSearchParams(window.location.search);

    // Carry Meta/UTM params into the install referrer for attribution.
    const referrer = new URLSearchParams({
      destination: "all-dish-detail",
      source: "meta_ads",
    });
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach((k) => {
      if (incoming.get(k)) referrer.set(k, incoming.get(k));
    });

    const playStoreUrl =
      `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}` +
      `&referrer=${encodeURIComponent(referrer.toString())}`;

    // Opens the app if installed, otherwise falls back to the Play Store.
    const appLink =
      `intent://shefscloud.com/get-app/dishes#Intent;scheme=https;` +
      `package=${ANDROID_PACKAGE};` +
      `S.browser_fallback_url=${encodeURIComponent(playStoreUrl)};end`;

    return { appLink, playStoreUrl };
  }, []);

  useEffect(() => {
    const ua = navigator.userAgent;
    if (/Android/i.test(ua)) {
      window.location.replace(appLink);
    } else if (/iPhone|iPad|iPod/i.test(ua) && IOS_APP_STORE_URL) {
      window.location.replace(IOS_APP_STORE_URL);
    }
    // Desktop: stay on this page and show the buttons below.
  }, [appLink]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white text-center px-6">
      <h1 className="text-2xl font-bold mb-2 text-gray-900">
        Taking you to the ShefsCloud app…
      </h1>

      <p className="text-gray-500 mb-6">
        If nothing happens, tap the button below.
      </p>

      <a
        href={appLink}
        className="inline-block bg-red-600 !text-white font-semibold px-6 py-3 rounded-full mb-3 hover:bg-red-700 transition-colors"
      >
        Open / Get the app
      </a>

      <a
        href={playStoreUrl}
        className="text-red-600 underline text-sm"
      >
        Go to Google Play
      </a>

      <a
        href="/all-dish-detail"
        className="text-gray-500 underline text-sm mt-6"
      >
        Continue on the website
      </a>
    </div>
  );
}